<template>
  <section>
    <v-card flat>
      <v-container style="padding-bottom: 100px">
        <v-data-table
          :headers="headersBudgets"
          :items="budgetList"
          hide-default-footer
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon @click="showBudgetDetail(item)" color="secondary">
              exit_to_app
            </v-icon>
          </template>
        </v-data-table>
      </v-container>

      <div class="bottom-bar" v-if="requestIsActive">
        <v-speed-dial
          style="justify-self: flex-end"
          direction="top"
          transition="slide-y-reverse-transition"
        >
          <template v-slot:activator>
            <v-btn color="secondary" dark fab @click="showBudgetDetail(null)">
              <v-icon>add</v-icon>
            </v-btn>
          </template>
        </v-speed-dial>
      </div>
    </v-card>
  </section>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  components: {},
  data() {
    return {
      requestId: null,
      selectedBudget: {},
      budgetDetailDialog: false,
      budgetList: [],
      headersBudgets: [
        { text: "ID", value: "id", show: true, sortable: false },
        { text: "Fecha", value: "created_at", show: true, sortable: false },
        {
          text: "Estado",
          value: "status_budget.name",
          sortable: false,
          show: true,
        },
        { text: "Detalle", value: "description", sortable: false, show: true },
        {
          text: "Monto mano de obra",
          value: "manpower_budget",
          show: true,
          sortable: false,
        },
        {
          text: "Monto materiales",
          value: "supplies_budget",
          show: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          align: "right",
          sortable: false,
          show: true,
        },
      ],
    };
  },
  mounted() {
    this.requestId = this.$route.query?.requestId;

    if (!this.requestId) {
      this.$router.back();
    }

    this.$store.commit(
      "set_app_title",
      `Preupuestos pedido #${this.requestId}`
    );
    window.scrollTo(0, 0);
    this.getBudgetList();
  },

  computed: {
    ...mapState("request", ["currentDetail"]),

    currentRequest() {
      return this.currentDetail?.request ?? null;
    },

    requestIsActive: function () {
      return (
        this.currentRequest?.status_request.id === 10 ||
        this.currentRequest?.status_request.id === 11 ||
        this.currentRequest?.status_request.id === 12
      );
    },
  },
  methods: {
    getBudgetList() {
      this.axios
        .get(`/budget/?request_id=${this.requestId}`)
        .then((response) => {
          this.budgetList = response.data.results;
        })
        .catch(() => {});
    },
    showBudgetDetail(budget) {
      if (budget) {
        this.$store.commit("set_current_budget", budget);
      } else {
        this.$store.commit("set_current_budget", {});
      }
      this.$router.push("budget-detail");
    },

    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    },
  },
};
</script>
<style scoped>
@media (min-width: 960px) {
  .pull-right-on-desktop {
    display: flex;
    justify-content: flex-end;
  }
}
.bottom-bar {
  position: fixed;
  padding: 0 24px;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 88px;
  display: flex;
  justify-content: flex-end;
}
.pb24 {
  padding-bottom: 84px;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.date {
  text-transform: capitalize;
  text-align: left;
}
.status-name-cont {
  height: 30px;
  background: #c8272a;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 12px;
  text-transform: capitalize;
}
</style>
